import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `<div>
  <p><strong>Description</strong></p>
  <p>
      This Alerts triggers when a Face to Face <span className="wikiinternallink"><a href="https://guided-coaching.corp.amazon.com/#/opportunities">Umbrella Guided Coaching Action</a></span> is generated.&nbsp;
  </p>
  <p><strong>Impact</strong></p>
  <p>
      The goal is to centralize alerting of all Manager Actions, including Umbrella’s Guided Coaching Actions, into Station Command Center’s (SCC) Work Items Tab so that operators have a single prioritized list of actions to work from.
      This also includes launching 10 new alerts while Delivering 90% at 80% Effectiveness.<br />
      Chime and/or email notifications of Alerts can be set up on the Work-Item Configuration Page, but each leader can only have one set of notification alerts. If a leader creates new notification settings, then the old notification
      settings that same leader previously created will be deleted. If your station wants notifications to go to different chime groups, then a separate leader will need to establish the notification settings for each group. A single
      leader cannot create notification settings for all groups.
  </p>
  <p><strong>Resolution Steps</strong></p>
  <p>
      1.Check <span className="wikiinternallink"><a href="https://guided-coaching.corp.amazon.com/#/opportunities">Umbrella Coaching Website</a></span> for Action.
  </p>
  <div className="wikimodel-emptyline"></div>
  <p><strong>Supplemental Links</strong></p>
  <p>
      1.
      <span className="wikiinternallink">
          <a
              href="https://us-east-1.quicksight.aws.amazon.com/sn/dashboards/5571ef06-acb5-4bae-a3ed-5d19a4859a62/sheets/5571ef06-acb5-4bae-a3ed-5d19a4859a62_2275a8a3-aa88-429c-91ea-77b6a5aedb77?directory_alias=amzlbiaquicksight&amp;qs-signin-user-auth=false"
          >
              FPY Dashboard
          </a>
      </span>
      <br />
      2.
      <span className="wikiinternallink">
          <a href="https://us-east-1.quicksight.aws.amazon.com/sn/dashboards/e5996fbe-2141-490a-adad-d5e8819be562/sheets/e5996fbe-2141-490a-adad-d5e8819be562_012c3736-bc21-428a-a187-996fe2ea26c2">
              NA AMZL Manager (SCC &amp; GCA) Alert Qicksight Dashboard
          </a>
      </span>
      <br />
      3.
      <span className="wikiinternallink">
          <a
              href="https://start.wwops.amazon.dev/boards/browse?boardId=IjEyMzE5Ig%3D%3D&amp;businessUnitId=IjMi&amp;cardId=IjIzNzcyMyI%3D&amp;selectedTagValueIds=WyIzMDQiLCIzMTUiLCIzNzkiXQ%3D%3D&amp;topLevelFilters=eyI0IjoiNDEiLCI2IjoiNDkifQ%3D%3D#h1-237723-1"
          >
              START Tetris
          </a>
      </span>
      <br />
      4.
      <span className="wikiinternallink">
          <a href="https://start.wwops.amazon.dev/boards/browse?boardId=IjE4NTI3Ig%3D%3D&amp;businessUnitId=IjMi&amp;selectedTagValueIds=WyIzMDQiLCIzMzA3IiwiMzY3Il0%3D&amp;topLevelFilters=eyI0IjoiNDEiLCI2IjoiNTgifQ%3D%3D#18527">
              START Problem Solve Sortation
          </a>
      </span>
  </p>
</div>
`
);



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_F2F_Coaching_Alert.jsx